module.exports = __webpack_public_path__ + "static/media/Img-banner-Premio-Ebit-02.d37ce8bf.d37ce8bf.png";